import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdDataOptions, getEntitiesByFpIdOnboardingsOptions } from '@onefootprint/fetch-dashboard';
import type { CustomRequirementContentPrompt, DataIdentifier } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { compareDesc, parseISO } from 'date-fns';

// Returns the playbook prompt used for the target field,
// or undefined if the field was not created from the custom form builder or created via a tenant-facing API
const useCustomFieldPlaybookPrompt = fpId => {
  const $ = _c(7);
  let t0;
  if ($[0] !== fpId) {
    t0 = getEntitiesByFpIdDataOptions({
      path: {
        fpId
      }
    });
    $[0] = fpId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: entityData
  } = useQuery(t0);
  let t1;
  if ($[2] !== fpId) {
    t1 = getEntitiesByFpIdOnboardingsOptions({
      path: {
        fpId
      }
    });
    $[2] = fpId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: onboardings
  } = useQuery(t1);
  let t2;
  if ($[4] !== entityData || $[5] !== onboardings?.data) {
    t2 = di => {
      const dataAttr = entityData?.find(d => d.identifier === di);
      const dataTimestamp = dataAttr?.createdAt;
      if (!dataTimestamp) {
        return;
      }
      const onboarding = onboardings?.data?.filter(t3 => {
        const {
          timestamp
        } = t3;
        return timestamp && parseISO(timestamp) <= parseISO(dataTimestamp);
      })?.sort(_temp)[0];
      if (!onboarding) {
        return;
      }
      const promptSections = onboarding.playbook?.customRequirements.flatMap(_temp2).filter(_temp3);
      return promptSections?.find(p => p.di === di)?.prompt;
    };
    $[4] = entityData;
    $[5] = onboardings?.data;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useCustomFieldPlaybookPrompt;
function _temp(a, b) {
  return compareDesc(parseISO(a.timestamp), parseISO(b.timestamp));
}
function _temp2(page) {
  return page.sections;
}
function _temp3(section) {
  return section.kind === "prompt";
}